import {
  FULLFILLMENT_ERROR,
  FULLFILLMENT_REQUEST,
  FULLFILLMENT_RESET,
  FULLFILLMENT_SUCCESS,
} from "./ActionType";

export const initialState = {
  isRequest: false,
  isSuccess: false,
  isError: false,
  fullfillment: null,
  error: null,
  shopId: null,
  requestId: null,
};

const hasRequestMeta = (meta) =>
  typeof meta?.shopId === "string" &&
  meta.shopId.length > 0 &&
  typeof meta?.requestId === "string" &&
  meta.requestId.length > 0;

const isActiveRequest = (state, meta) =>
  hasRequestMeta(meta) &&
  state.shopId === meta.shopId &&
  state.requestId === meta.requestId;

const fullfillmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case FULLFILLMENT_REQUEST:
      if (!hasRequestMeta(action.meta)) return state;
      return {
        isRequest: true,
        isSuccess: false,
        isError: false,
        fullfillment: null,
        error: null,
        shopId: action.meta.shopId,
        requestId: action.meta.requestId,
      };
    case FULLFILLMENT_SUCCESS:
      if (!isActiveRequest(state, action.meta)) return state;
      return {
        ...state,
        isRequest: false,
        isSuccess: true,
        isError: false,
        fullfillment: action.payload,
        error: null,
      };

    case FULLFILLMENT_ERROR:
      if (!isActiveRequest(state, action.meta)) return state;
      return {
        ...state,
        isRequest: false,
        isSuccess: false,
        isError: true,
        fullfillment: null,
        error: action.payload,
      };
    case FULLFILLMENT_RESET:
      return initialState;
    default:
      return state;
  }
};

export default fullfillmentReducer;
